import React from 'react';
import { observer } from 'mobx-react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import * as uuid from 'uuid';
import { GlobalToken } from 'antd';

import { useStores } from '@/hooks/use-stores';

import ReportsHeader from './components/ReportsHeader';
import ValueDashboardReportPage from './ValueDashboardReportPage/ValueDashboardReportPage';

const PdfReportsPage = observer(() => {
  const { stationStore } = useStores();
  const { stationId } = useParams();
  const navigate = useNavigate();
  if (!uuid.validate(stationId)) navigate(`/home/station/${stationStore.stations[0]?.id}`);
  stationStore.setCurrentStation(stationId);

  return (
    <Container>
      <ReportsHeader />

      <div className="content-container">
        <Routes>
          <Route path="value-dashboard/*" element={<ValueDashboardReportPage />} />

          <Route path="*" element={<Navigate replace to="tab" />} />
        </Routes>
      </div>
      <div className="page-container no-top-padding no-bottom-padding">
        <hr />
      </div>
    </Container>
  );
});

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  .page-container {
    padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingLG}px;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    position: relative;

    &.no-top-padding {
      padding-top: 0;
    }

    &.no-bottom-padding {
      padding-bottom: 0;
    }

    hr {
      height: 2px;
      color: ${({ theme: { token } }) => token.colorBorderSecondary};
    }
  }

  .content-container {
    margin-top: ${({ theme: { token } }) => token.margin}px;

    .description {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }
  }
`;

export default PdfReportsPage;
